import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import BidDetail from './BidDetail';
import HotelFeedbackLink from './HotelFeedbackLink';

class BidDetailPanel extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <h4>
          <Button onClick={this.props.onClose}>
            <i className="fa fa-arrow-left" aria-hidden="true" /> Back
          </Button>
        </h4>
        <BidDetail
          bid={this.props.bid}
          editBid={this.props.editBid}
          addBidNote={this.props.addBidNote}
          sendBid={this.props.sendBid}
          user={this.props.user}
        />
        <div className="pull-right">
          <HotelFeedbackLink id={this.props.bid.hotel.id} />
        </div>
      </div>
    );
  }
}

BidDetailPanel.propTypes = {
  bid: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
};

BidDetailPanel.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default BidDetailPanel;



// WEBPACK FOOTER //
// src/routes/booking/components/BidDetailPanel.js